module.exports = __webpack_public_path__ + "fonts/dFa5ZfeM_74wlPZtksIFYskZ6HOpW3pwfa0.woff2";